export const FORM_ENTITY_TYPE_MAP = {
  "SECTION": "SECTION",
  "BLOCK": "BLOCK",
  "FIELD": "FIELD",
  "LAYOUT": "LAYOUT",
}

export const SECTION_STATUS_MAP = {
  "COMPLETED": "COMPLETED",
  /// ... add other states as needed
}

export const HIGHLIGHT_COLOR_MAP = {
  WARNING: "#FBECA2",
}

export const FIELD_TYPES_WITHOUT_LOGS = [
  'label info rich text',
  'Label'
]